import { Pipe, PipeTransform } from '@angular/core';
import { job_level } from '@app/config/job-level.enum';

@Pipe({
  name: 'levelName'
})
export class LevelNamePipe implements PipeTransform {

  transform(value: number | string): string {

    const el = job_level.find(e => +e.id === +value);

    if (el === undefined)
      return '';

    return el?.text;
  }
}
